import { ICouponDiscount } from '../../interface/product.interfaces';
import constant from './constant';

interface IMyGiftInitialState {
  isVisibleDetailGift: { show: boolean; listType: 'page' | 'modal' };
  detailGift: ICouponDiscount | null;
  isVisibleListGiftModal: boolean;
}

const INITIAL_STATE: IMyGiftInitialState = {
  isVisibleDetailGift: { show: false, listType: 'page' },
  detailGift: null,
  isVisibleListGiftModal: false,
};

const reducer = (
  state = INITIAL_STATE,
  action: { type: string; payload: any }
): IMyGiftInitialState => {
  switch (action.type) {
    case constant.SET_DETAIL_GIFT_VOUCHER:
      return { ...state, detailGift: action.payload };
    case constant.SET_SHOW_DETAIL_GIFT_VOUCHER:
      return { ...state, isVisibleDetailGift: action.payload };
    case constant.SET_SHOW_LIST_GIFT_VOUCHER_MODAL:
      return { ...state, isVisibleListGiftModal: action.payload };
    default:
      return state;
  }
};

export default reducer;
